<template>
  <component
    :is="activeComp"
    :settings="activeSettings"
    @updateSettings="updateSettings"
    @removeBookmarks="removeBookmarks"
    @clearSorting="clearSorting"
    @resetStory="resetStory"
    @changeLayout="changeLayout"
    @redrawAnalysis="redrawAnalysis"
  ></component>
</template>

<script>
import AnalysisSettings from "./Settings/AnalysisSettings";
import FieldsSettings from "./Settings/FieldsSettings";
import FocusSettings from "./Settings/FocusSettings";
import StorySettings from "./Settings/StorySettings";
export default {
  name: "PanelTop",
  components: {
    FieldsSettings,
    StorySettings,
    FocusSettings,
    AnalysisSettings
  },
  props: {
    settingsPanel: {
      type: String,
      required: true
    },
    settings: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      activeComp: null,
      activeSettings: null
    };
  },
  watch: {
    settings(val) {
      this.activeSettings = val;
    }
  },
  mounted() {
    this.activeComp = this.settingsPanel;
    this.activeSettings = this.settings;
  },
  methods: {
    updateSettings(settings) {
      this.$emit("updateSettings", settings);
    },
    removeBookmarks() {
      this.$emit("removeBookmarks");
    },
    clearSorting() {
      this.$emit("clearSorting");
    },
    resetStory() {
      this.$emit("resetStory");
    },
    changeLayout(layout) {
      this.$emit("changeLayout", layout);
    },
    redrawAnalysis() {
      this.$emit("redrawAnalysis");
    }
  }
};
</script>
